import React from "react";

import { Route, Routes } from "react-router-dom";

import { Page404 } from "@components/title-slide-view";
import { useUser } from "@components/user-context";

import { CustomerLtvV2 } from "./customer-ltv-v2";
import { DocumentsPage } from "./documents";
import { PathsPage } from "./paths";
import { Report } from "./report";

const Customers = () => {
  const { user } = useUser();

  return (
    <Routes>
      {user.featureFlags.customerLtvV2 ? (
        <Route index element={<CustomerLtvV2 />} />
      ) : (
        <Route index element={<Report />} />
      )}
      <Route path="/documents" element={<DocumentsPage />} />
      <Route path="/paths" element={<PathsPage />} />
      <Route path="/*" element={<Page404 />} />
    </Routes>
  );
};

export default Customers;
